import { createContext, useContext } from "react"
export type SceneContext = {
    scene: string
    setScene: (c: string) => void
    gotoScene: string
    setGotoScene: (c: string) => void
    act: string
    setAct: (c: string) => void
    aniHeight: number,
    setAniHeight: (c: number) => void
}
export const AppSceneContext = createContext<SceneContext>({
    scene: 'chat',
    gotoScene: '',
    setGotoScene: () => { },
    act: '',
    setScene: () => { },
    setAct: () => { },
    aniHeight: 0,
    setAniHeight: () => { }
})
export const useAppSceneContext = () => useContext(AppSceneContext)